import gql from 'graphql-tag'

export const getContentHelpersFromGql = () => gql`
  query getContentHelpers($contentId: String) {
    getContentHelpers(contentId: $contentId) {
      results {
        title
        message
        contentId
        enabled
      }
      total
      errors
    }
  }
`
